export { DetailHeaderOrg, DetailHeaderOrgLoading } from './DetailHeaderOrg';
